import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCreditInfoList(params) {
  return request({
    url: URL.partner.creditInfo,
    method: 'get',
    params
  })
}

export function saveCreditInfo(data) {
  return request({
    url: URL.partner.creditInfo,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delCreditInfo(uuid) {
  return request({
    url: URL.partner.creditInfo + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function checkCreditInfo(params, data) {
  if (!data) {
    data = {}
  }
  return request({
    url: URL.partner.checkCreditInfo,
    method: 'post',
    params,
    data
  })
}

export function creditCheck(params) {
  return request({
    url: URL.partner.creditCheck,
    method: 'get',
    params
  })
}

export function batchCheckCreditInfoFunc(data) {
  return request({
    url: URL.partner.batchCheckCreditInfoUrl,
    method: 'post',
    data
  })
}

export function queryCustomerCompanyIsOver(params) {
  return request({
    url: URL.partner.queryCustomerCompanyIsOver,
    method: 'get',
    params
  })
}

export function canCreateByCreditInfoDetail(data) {
  return request({
    url: URL.partner.canCreateByCreditInfoDetail,
    method: 'post',
    data
  })
}

export function canCreateByCreditInfoDetails(data) {
  return request({
    url: URL.partner.canCreateByCreditInfoDetails,
    method: 'post',
    data
  })
}

export function searchCompanyForCreditPermit(data) {
  return request({
    url: URL.partner.searchCompanyForCreditPermit,
    method: 'post',
    data
  })
}

export function checkEtdDaysCreditInfo(params) {
  return request({
    url: URL.partner.checkEtdDaysCreditInfo,
    method: 'get',
    params
  })
}

export function checkJobAtdDescFunc(params) {
  return request({
    url: URL.partner.checkJobAtdDescUrl,
    method: 'get',
    params
  })
}

export function searchCompanyForCreditControlNew(data) {
  return request({
    url: URL.partner.searchCompanyForCreditControlNew,
    method: 'post',
    data
  })
}

export function saveTempCreditInfo(data) {
  return request({
    url: URL.partner.saveTempCreditInfo,
    method: 'post',
    data
  })
}

export function searchCreditOutCharge(data) {
  return request({
    url: URL.partner.searchCreditOutCharge,
    method: 'post',
    data
  })
}

export function neglect(data) {
  return request({
    url: URL.partner.creditOutChargeNeglect,
    method: 'post',
    data
  })
}
export function neglectRollback(data) {
  return request({
    url: URL.partner.creditOutChargeNeglectRollBack,
    method: 'post',
    data
  })
}

export function neglectBatch(data) {
  return request({
    url: URL.partner.creditOutChargeNeglectBatch,
    method: 'post',
    data
  })
}
export function neglectRollbackBatch(data) {
  return request({
    url: URL.partner.creditOutChargeNeglectRollBackBatch,
    method: 'post',
    data
  })
}

export function availableReleaseDocRuleGroupList(params) {
  return request({
    url: URL.act.releaseDocRule.availableReleaseDocRuleGroupList,
    method: 'get',
    params
  })
}

export function getDefaultCreditInfo(params) {
  return request({
    url: URL.partner.getDefaultCreditInfo,
    method: 'post',
    params
  })
}

export function getDefaultAndBaoDiCreditInfo(params) {
  return request({
    url: URL.partner.getDefaultAndBaoDiCreditInfo,
    method: 'post',
    params
  })
}

export function saveDefaultCreditInfo(data) {
  return request({
    url: URL.partner.saveDefaultCreditInfo,
    method: 'post',
    data
  })
}

export function saveDefaultAndBaoDiCreditInfo(data) {
  return request({
    url: URL.partner.saveDefaultAndBaoDiCreditInfo,
    method: 'post',
    data
  })
}

export function getCreditInfoByJobUuid(params) {
  return request({
    url: URL.partner.getCreditInfoByJobUuid,
    method: 'get',
    params
  })
}

export function getApprovingContractOrCompany(params) {
  return request({
    url: URL.partner.getApprovingContractOrCompany,
    method: 'get',
    params
  })
}

export function saveTempCreditInfoChange(data) {
  return request({
    url: URL.partner.saveTempCreditInfoChange,
    method: 'post',
    data
  })
}

export function syncTempCreditInfo(data) {
  return request({
    url: URL.partner.syncTempCreditInfoUrl,
    method: 'post',
    data
  })
}

export function saveCreditInfoRemark(data) {
  return request({
    url: URL.partner.saveCreditInfoRemark,
    method: 'post',
    data
  })
}
